/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import Icon from "react-icons-kit";
import { videoCamera } from "react-icons-kit/fa/videoCamera";

import { Text } from "UpduoLibrary";
import { skaleGreen, skaleOrange, skaleWhite } from "config/UpduoColors";

interface SummitStatusCardProps {
  summitHasEnded: boolean;
  summitIsLive: boolean;
  endedText?: string;
  endedColor?: string;
  showEndedCard?: boolean;
}

export default function SummitStatusCard({
  summitHasEnded,
  summitIsLive,
  endedText = "COMPLETE",
  endedColor = skaleWhite,
  showEndedCard = true,
}: SummitStatusCardProps) {
  const liveButton = (
    <View
      style={{
        justifyContent: "space-around",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: skaleOrange,
        borderRadius: 3,
        width: 67,
        height: 23,
        paddingHorizontal: 6,
      }}
    >
      <div
        style={{
          color: skaleWhite,
          paddingBottom: 6,
          paddingLeft: 1,
        }}
      >
        <Icon size={12} icon={videoCamera} />
      </div>
      <Text
        isHeading={true}
        style={{ color: skaleWhite, fontSize: 12, letterSpacing: 1 }}
      >
        {"LIVE"}
      </Text>
    </View>
  );

  const completeButton = (
    <View
      style={{
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center",
        borderWidth: 1,
        borderColor: endedColor,
        borderRadius: 3,
        width: 90,
        height: 23,
      }}
    >
      <Text isHeading={true} style={{ color: endedColor, fontSize: 12 }}>
        {endedText}
      </Text>
    </View>
  );

  const upcomingButton = (
    <View
      style={{
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center",
        borderWidth: 1,
        borderColor: skaleGreen,
        borderRadius: 3,
        width: 90,
        height: 23,
      }}
    >
      <Text
        isHeading={true}
        style={{ color: skaleGreen, fontSize: 12, marginLeft: 1 }}
      >
        {"UPCOMING"}
      </Text>
    </View>
  );

  return (
    <View>
      {summitHasEnded
        ? showEndedCard
          ? completeButton
          : null
        : summitIsLive
        ? liveButton
        : upcomingButton}
    </View>
  );
}
